import React from 'react'
import LocalDashBoard from './Local/LocalDashboard'
import GlobalDashboard from './Global/GlobalDashboard'

function MainDashboard(){
    return(
        <React.Fragment>
            <LocalDashBoard />
            <GlobalDashboard />
        </React.Fragment>
    )
}

export default MainDashboard